export default __webpack_public_path__ + "static/media/cohort-meditation.47bd3d94.svg";